module.exports = __webpack_public_path__ + "static/media/CircularStdBlack.59880bb7.woff";